import React from 'react'
import { Box } from 'theme-ui'
import ContentBoxes from '../components/ContentBoxes/v3/ContentBoxes'
export default function ContentBoxesV3(props) {
  const {
    options,
    // businessData,
    variantName
    // configData,
    // locationIndex,
  } = props
  const { containerStyles } = options

  const variant = variantName ? variantName : 'contentBoxesV3'
  const styles = containerStyles ? JSON.parse(containerStyles) : {}

  return (
    <Box variant={`${variant}.container`} sx={styles}>
      <ContentBoxes {...props} variantName={variant} />
    </Box>
  )
}
